module.exports = __webpack_public_path__ + "media/images/first-championship-desktop-bc5422447d131e0636eb03cc34952bb3.jpg";